import React from 'react';
import PropTypes from 'prop-types';

function Visa({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="12"
      viewBox="0 0 40 12"
      className={className}
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-25 -18)">
          <g>
            <g fillRule="nonzero" transform="translate(25 18)">
              <path
                fill="#0E4595"
                d="M14.0427333 11.6824434L16.0690608 0.188426506 19.3087582 0.188426506 17.2824307 11.6824434z"
              />
              <path
                fill="#0E4595"
                d="M29.06.482C28.416.247 27.41 0 26.148 0c-3.212 0-5.48 1.563-5.497 3.796-.019 1.652 1.615 2.574 2.852 3.127 1.268.564 1.694.922 1.688 1.428-.006.77-1.011 1.122-1.944 1.122-1.304 0-1.993-.176-3.06-.605l-.42-.182-.457 2.574c.762.323 2.163.6 3.62.61 3.42 0 5.638-1.539 5.662-3.93.013-1.311-.853-2.304-2.73-3.127-1.134-.535-1.835-.887-1.829-1.428 0-.476.592-.987 1.865-.987a6.115 6.115 0 012.432.44l.293.136.439-2.492"
              />
              <path
                fill="#0E4595"
                d="M37.387.188H34.91c-.769 0-1.34.206-1.676.952l-4.76 10.542h3.366l.673-1.727 4.104.006c.096.405.39 1.721.39 1.721h2.975L37.387.188zm-3.93 7.434l1.28-3.214c-.018.029.264-.664.427-1.1l.216.994s.613 2.744.745 3.32h-2.668z"
              />
              <path
                fill="#0E4595"
                d="M11.423.188l-3.136 7.85-.337-1.594c-.582-1.84-2.403-3.833-4.44-4.827l2.872 10.065 3.395-.005L14.823.188h-3.4"
              />
              <path
                fill="#F2AE14"
                d="M.042.188L0 .428c4.027.946 6.83 3.234 7.937 5.979L6.812 1.152C6.619.434 5.917.218 5.219.188H.042z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

Visa.propTypes = {
  className: PropTypes.string,
};

Visa.defaultProps = {
  className: undefined,
};

export default Visa;
